const host = 'https://us-central1-pauseable-e4aa1.cloudfunctions.net';
export const verificationCodeUrl = host + '/verifyTeamSignup';
export const teamInviteUrl = host + '/teamInvite';
